<template>
  <div>
    <Toolbar />
    <h3 style="margin: 10px">Ingresa tu firma en el recuadro de abajo:</h3>

    <div class="signature-pad">
      <canvas
        ref="canvas"
        :class="[
          'signature-pad-canvas',
          { 'signature-pad-canvas--disabled': cargandoCreacionSolicitud },
        ]"
        @touchstart.prevent="startDrawing"
        @touchmove.prevent="draw"
        @touchend.prevent="stopDrawing"
        @touchcancel.prevent="stopDrawing"
        @mousedown.prevent="startDrawing"
        @mousemove.prevent="draw"
        @mouseup.prevent="stopDrawing"
        @mouseleave.prevent="stopDrawing"
      ></canvas>

      <div class="signature-actions">
        <v-btn
          :disabled="cargandoCreacionSolicitud"
          color="primary"
          @click="clearCanvas"
        >
          Limpiar
        </v-btn>

        <v-btn
          color="primary"
          @click="getSignatureImage"
          :disabled="cargandoCreacionSolicitud || !isAlreadyDrawing"
          :loading="cargandoCreacionSolicitud"
        >
          Firmar y Continuar
        </v-btn>
      </div>
    </div>

    <div
      v-if="$store.getters['credito/obtenerObservacionesDevolucion'] != ''"
      class="observaciones-firma"
    >
      <v-alert
        dense
        text
        type="info"
        :icon="false"
        class="text-center font-weight-black ma-0"
      >
        <p>Observaciones:</p>
        <p>{{ $store.getters['credito/obtenerObservacionesDevolucion'] }}</p>
      </v-alert>
    </div>
  </div>
</template>

<script>
import Toolbar from '@/components/compartidos/Toolbar.vue'
import { mapActions, mapGetters } from 'vuex'
import CreditoService from '@/servicios/credito'
import PersonaService from '@/servicios/persona'
import { ALERTA_ERROR } from '@/utilidades/utilidades'
import { GuardaFirmaAutografaDigitalMixin } from '@/mixins/persona/GuardaFirmaAutografaDigital.mixin'
import { ActualizaEstatusSolicitudMixin } from '@/mixins/credito/ActualizaEstatusSolicitud.mixin'

export default {
  components: {
    Toolbar,
  },
  mixins: [GuardaFirmaAutografaDigitalMixin, ActualizaEstatusSolicitudMixin],
  data() {
    return {
      isDrawing: false,
      cargandoCreacionSolicitud: false,
      isAlreadyDrawing: false,
      lastX: 0,
      lastY: 0,
    }
  },
  mounted() {
    this.isAlreadyDrawing = false
    this.resizeCanvas()
    window.addEventListener('resize', this.resizeCanvas)
  },
  computed: {
    ...mapGetters({
      obtenerOtpFirma: 'credito/obtenerOtpFirma',
      obtenerEsOtpFirmaValido: 'credito/obtenerEsOtpFirmaValido',
      obtenerAceptaFirmar: 'credito/obtenerAceptaFirmar',
      obtenerSonTerminosBuroConfirmados:
        'credito/obtenerSonTerminosBuroConfirmados',
      obtenerCredito: 'credito/obtenerCredito',
    }),
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCanvas)
  },
  methods: {
    postActualizaEstatusSolicitud() {
      this.cargandoCreacionSolicitud = false
      this.$store.dispatch('credito/actualizarConfirmacion', false)
      this.$router.push('terminacionActualizacion')
    },

    setCanvasStyles(ctx) {
      ctx.strokeStyle = '#000'
      ctx.lineWidth = 1.2
      ctx.lineCap = 'round'
      ctx.lineJoin = 'round'
    },

    resizeCanvas() {
      const canvas = this.$refs.canvas
      if (!canvas) return

      const rect = canvas.getBoundingClientRect()
      const dpr = window.devicePixelRatio || 1

      canvas.width = Math.round(rect.width * dpr)
      canvas.height = Math.round(rect.height * dpr)

      const ctx = canvas.getContext('2d')
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0)
      this.setCanvasStyles(ctx)
    },

    getPoint(e) {
      const canvas = this.$refs.canvas
      const rect = canvas.getBoundingClientRect()

      let clientX = 0
      let clientY = 0

      if (e.touches && e.touches.length > 0) {
        clientX = e.touches[0].clientX
        clientY = e.touches[0].clientY
      } else if (e.changedTouches && e.changedTouches.length > 0) {
        clientX = e.changedTouches[0].clientX
        clientY = e.changedTouches[0].clientY
      } else {
        clientX = e.clientX
        clientY = e.clientY
      }

      return {
        x: clientX - rect.left,
        y: clientY - rect.top,
      }
    },

    startDrawing(e) {
      e.preventDefault()
      if (this.cargandoCreacionSolicitud) return

      const point = this.getPoint(e)

      this.isAlreadyDrawing = true
      this.isDrawing = true
      this.lastX = point.x
      this.lastY = point.y
    },

    draw(e) {
      e.preventDefault()
      if (!this.isDrawing || this.cargandoCreacionSolicitud) return

      const point = this.getPoint(e)
      const ctx = this.$refs.canvas.getContext('2d')

      ctx.beginPath()
      ctx.moveTo(this.lastX, this.lastY)
      ctx.lineTo(point.x, point.y)
      ctx.stroke()

      this.lastX = point.x
      this.lastY = point.y
    },

    stopDrawing(e) {
      if (e) e.preventDefault()
      this.isDrawing = false
    },

    clearCanvas() {
      this.isAlreadyDrawing = false

      const canvas = this.$refs.canvas
      const ctx = canvas.getContext('2d')
      const dpr = window.devicePixelRatio || 1

      ctx.setTransform(1, 0, 0, 1, 0, 0)
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0)
      this.setCanvasStyles(ctx)
    },

    getSignatureImage() {
      this.isDrawing = false
      this.cargandoCreacionSolicitud = true

      const canvas = this.$refs.canvas
      const imageDataURL = canvas.toDataURL('image/png')
      let valor = imageDataURL.split(',')
      let folioDigital = localStorage.getItem('FOLIO_DIGITAL')
      folioDigital = folioDigital.replace(/['"]+/g, '')

      const request = {
        folioDigital: folioDigital.toString(),
        base64Firma: valor[1],
      }

      this.GuardaFirmaAutografaDigital(request)

      if (this.$store.getters['credito/obtenerAplicaDevolucion'] == 1) {
        const idSolicitud = this.$store.getters['credito/obtenerIdSolicitud']
        this.actualizaEstatusSolicitud(idSolicitud)
      } else {
        this.crearSolicitud().then(() => {
          this.cargandoCreacionSolicitud = false
          this.$router.push('/terminacion')
        })
      }
    },

    async crearSolicitud() {
      let result
      const crearSolicitudRequest =
        this.$store.getters['credito/obtenerSolicitudDigitalRequest']

      try {
        if (this.$store.getters['credito/obtenerAplicaDevolucionMonto']) {
          result = await CreditoService.actualizaMontoSolicitudDigital(
            crearSolicitudRequest
          )
        } else {
          result = await CreditoService.insertarSolicitudDigital(
            crearSolicitudRequest
          )

          console.log(JSON.stringify(crearSolicitudRequest))
        }

        if (result.data.Codigo == 200 && result.data.Estado == true) {
          let resultadoActualizacionPersona
          this.$store.dispatch(
            'personaDocumentos/insertarComprobante',
            result.data.Modelo.Comprobante
          )

          const persona = this.$store.getters['persona/obtenerPersona']

          if (persona.tipoPersona == 2) {
            resultadoActualizacionPersona =
              await PersonaService.actualizarDomicilioProspecto(persona)

            if (
              resultadoActualizacionPersona.data.Codigo == 200 &&
              resultadoActualizacionPersona.data.Estado == true
            ) {
              this.$store.dispatch('credito/actualizarConfirmacion', false)
              this.$store.dispatch('credito/actualizarFinalizado', true)

              console.log('Llega aqui al final de todo')
              this.cargandoCreacionSolicitud = false
              this.$router.push('terminacion')
            } else {
              this.enviarAlertaError({
                mensaje:
                  'Ha ocurrido un error al procesar tu solicitud. Por favor, intente acceder de nuevo al link que recibió vía Whatsapp y reinicie el proceso.',
                tiempo: ALERTA_ERROR.tiempo,
                visibilidad: ALERTA_ERROR.visible,
              })
              this.cargandoCreacionSolicitud = false
            }
          } else {
            this.$store.dispatch('credito/actualizarConfirmacion', false)
            this.$store.dispatch('credito/actualizarFinalizado', true)
            this.$router.push('terminacion')
            this.cargandoCreacionSolicitud = false
          }
        } else {
          // TODO: re-habilitar cuando backend corrija el error de correo no registrado
          // this.enviarAlertaError({
          //   mensaje:
          //     result.data.Modelo?.Mensaje ||
          //     'Ha ocurrido un error al procesar tu solicitud. Por favor, intente acceder de nuevo al link que recibió vía Whatsapp y reinicie el proceso.',
          //   tiempo: ALERTA_ERROR.tiempo,
          //   visibilidad: ALERTA_ERROR.visible,
          // })
          console.error(result.data.Modelo?.Mensaje || result.data.Mensaje)
          this.cargandoCreacionSolicitud = false
        }
      } catch (error) {
        console.error(error)
        this.cargandoCreacionSolicitud = false
      }
    },

    ...mapActions({
      enviarAlertaError: 'alerta/enviarAlertaError',
      enviarAlertaExito: 'alerta/enviarAlertaExito',
      actualizaOTP: 'credito/actualizaOtpFirma',
      setEsOtpFirmaValido: 'credito/setEsOtpFirmaValido',
      setAceptaFirmar: 'credito/setAceptaFirmar',
      setSonTerminosBuroConfirmados: 'credito/setSonTerminosBuroConfirmados',
    }),
  },
}
</script>

<style scoped>
.signature-pad {
  width: 90%;
  max-width: 700px;
  margin: 0 auto;
}

.signature-pad-canvas {
  display: block;
  width: 100%;
  height: 320px;
  border: 1px solid #000;
  background: #fff;
  touch-action: none;
  box-sizing: border-box;
}

.signature-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  flex-wrap: wrap;
}

.observaciones-firma {
  width: 90%;
  max-width: 700px;
  margin: 16px auto 0;
}

.signature-pad-canvas--disabled {
  pointer-events: none;
  opacity: 0.95;
}
</style>
